import React, { useEffect, useRef, useState } from "react";
import { useUser } from "../../../../context/UserContext";
import { User, ListOrdered, Heart, LogOut } from "lucide-react";
import AuthPage from "../../../../pages/customer/auth/AuthPage";
import "./UserDropdown.css";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../../../../context/LanguageContext";

const UserDropdown = ({ open, onClose }) => {
  const location = useLocation();
  const { language } = useLanguage();
  const { currentUser, logout } = useUser();
  const dropdownRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  const translations = {
    en: {
      myAccount: "My Account",
      orders: "Orders",
      wishlist: "Wishlist",
      logout: "Logout",
    },
    ar: {
      myAccount: "حسابي",
      orders: "الطلبات",
      wishlist: "قائمة الأمنيات",
      logout: "تسجيل الخروج",
    },
  };

  const t = translations[language] || translations.en;

  // detect scroll for styling
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // handle logout
  const handleLogout = async () => {
    try {
      await logout();
      onClose();
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  // ❌ don't render anything if not open
  if (!open) return null;

  return (
    <>
      {currentUser ? (
        <div className="user-overlay" onClick={onClose}>
          <div className="user-sidebar" onClick={(e) => e.stopPropagation()}>
            <div className="user-info">
              <p className="user-name">{currentUser?.displayName || "User"}</p>
              <p className="user-email">{currentUser?.email}</p>
            </div>

            <div className="divider"></div>

            <Link to="/account" className="sidebar-item" onClick={onClose}>
              <User />
              <span>{t.myAccount}</span>
            </Link>

            <Link to="/orders" className="sidebar-item" onClick={onClose}>
              <ListOrdered />
              <span>{t.orders}</span>
            </Link>

            <Link to="/wishlist" className="sidebar-item" onClick={onClose}>
              <Heart />
              <span>{t.wishlist}</span>
            </Link>

            <div className="divider"></div>

            <div className="sidebar-item" onClick={handleLogout}>
              <LogOut />
              <span>{t.logout}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="guest-auth">
          <div className="auth-box">
            <AuthPage panelMode={false} onClose={onClose} />
          </div>
        </div>
      )}
    </>
  );
};

export default UserDropdown;
